import { render, staticRenderFns } from "./DisbursementPendingStatusAlert.vue?vue&type=template&id=47c762f2&"
import script from "./DisbursementPendingStatusAlert.vue?vue&type=script&lang=js&"
export * from "./DisbursementPendingStatusAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports